/*
 * Calculates the angle between three points.
 * @param {Array} a - The first point.
 * @param {Array} b - The second point.
 * @param {Array} c - The third point.
 */
function calculateAngle (a, b, c) {
  const v1 = { x: a[0] - b[0], y: a[1] - b[1] }
  const v2 = { x: c[0] - b[0], y: c[1] - b[1] }

  const dotProduct = v1.x * v2.x + v1.y * v2.y
  const magnitude1 = Math.sqrt(v1.x ** 2 + v1.y ** 2)
  const magnitude2 = Math.sqrt(v2.x ** 2 + v2.y ** 2)

  if (magnitude1 * magnitude2 === 0) {
    return 0
  }

  const angle = Math.acos(dotProduct / (magnitude1 * magnitude2))

  return Math.min(angle, Math.PI * 2 - angle)
}

/*
 * Calculates the miter limit for a corner point.
 * @param {Array} start - The start point of the corner.
 * @param {Array} corner - The corner point.
 * @param {Array} end - The end point of the corner.
 */
function calculateMiterLength (start, corner, end) {
  // If start and corner are the same, or corner and end are the same,
  // then we have a straight line, so return a very large miter limit
  if ((start[0] === corner[0] && start[1] === corner[1]) ||
      (corner[0] === end[0] && corner[1] === end[1])) {
    return 0
  }
  // Calculate the angle at the corner point
  const angle = calculateAngle(start, corner, end)

  // // Avoid division by zero for straight lines or very small angles
  if (angle === 0 || Math.sin(angle / 2) === 0) {
    return 0 // no miter
  }

  // Calculate the miter length
  return 1 / (2 * Math.sin(angle / 2))
}

function parse (path) {
  const commands = path.match(/[MmLlZz][^MmLlZz]*/g)
  if (!commands) {
    return []
  }

  let currentPoint = [0, 0]
  const points = []

  commands.forEach(command => {
    const type = command[0]
    const commandPoints = command.substring(1).trim().split(/,|\s/).map(Number)

    for (let i = 0; i < commandPoints.length; i += 2) {
      let x = commandPoints[i]
      let y = commandPoints[i + 1]

      if (type === 'm' || type === 'l') {
        // For relative commands, add the values to the current position
        x += currentPoint[0]
        y += currentPoint[1]
      }

      if (type.toLowerCase() === 'm' || type.toLowerCase() === 'l') {
        currentPoint = [x, y]
        points.push(currentPoint)
      }
    }
  })

  return points
}


/*
 * Returns the max miter limit for a path.
 * by calculating the miter limit for each corner point.
 * @param {String} path - The path to calculate the miter limit for.
 */
export default function (path) {
  const points = parse(path)

  let max = 0

  for (let i = 1; i < points.length - 1; i++) {
    const p1 = points[i - 1]
    const p2 = points[i]
    const p3 = points[i + 1]

    const miter = calculateMiterLength(p1, p2, p3)

    if (miter > max) {
      max = miter
    }
  }

  return max
}
